/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Check({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M13.378 3.534a.6.6 0 0 1 .088.844l-6.5 8a.6.6 0 0 1-.918.017l-3.5-4a.6.6 0 0 1 .904-.79l3.031 3.464 6.051-7.447a.6.6 0 0 1 .844-.088Z" clipRule="evenodd" /></svg>;
}
;